import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TUserCredential {
  username: string;
  password: string;
  language?: string;
}

export interface IUserCredential extends TUserCredential {}

const UserCredential = Model((model: TUserCredential): IUserCredential => {
  const _userCredential: TUserCredential = { ...model };

  let create = (userCredentials: IUserCredential): IUserCredential =>
    ValidatableObject(userCredentials);

  const userCredential = {
    get username() {
      return _userCredential.username;
    },
    set username(value) {
      _userCredential.username = value;
    },
    get password() {
      return _userCredential.password;
    },
    set password(value) {
      _userCredential.password = value;
    },
    get language() {
      return _userCredential.language;
    },
    set language(value) {
      _userCredential.language = value;
    }
  };

  return create(userCredential);
});

export default UserCredential;
